import { combineReducers } from "redux";

import getSalaryDetail from "./getSalaryDetail";
import verifyIncomeOtp from "./verifyIncomeOtp";
import getListNotifyIncome from "./getListNotifyIncome";
import getDetailNotifyIncome from "./getDetailNotifyIncome";

const salaryReducer = combineReducers({
  getSalaryDetail,
  verifyIncomeOtp,
  getListNotifyIncome,
  getDetailNotifyIncome,
});

export default salaryReducer;
